import React from 'react';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 5, // 5 minutes
            gcTime: 1000 * 60 * 30, // 30 minutes
            refetchOnWindowFocus: false,
        },
    },
});

export const AppQueryProvider: React.FC<{children: React.ReactNode}> = ({children}) => {
    return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};
